import type { IndustryType } from '@/types';

export const MODEL_LABELS: Record<string, string> = {
  '1RE': '1 Room Talent',
  '2RE': '2 Room Talent',
  '3RE': '3 Room Talent',
  'WEA': 'Wardrobe',
  'HNY': 'Honeywagon',
  'ELC': 'Electrical',
  'FLD': 'Field Office',
  'PLL': 'Polling Station',
  'MED': 'Medical',
  'SLP': 'Sleeper',
  'SUR': 'Surveyor',
  'ENG': 'Engineering',
  'CMD': 'Command Center',
  'OFF': 'Office',
  'VIP': 'VIP',
  'CAT': 'Catering',
  'MU4': 'Makeup 40ft',
  'MU5': 'Makeup 53ft',
};

export const INDUSTRY_TYPE_LABELS: Record<string, string> = {
  film: 'FILM',
  event: 'EVENT',
  gov: 'GOVERNMENT',
  utility: 'UTILITY',
  relief: 'RELIEF',
};

export const INDUSTRY_TYPE_ORDER: IndustryType[] = ['film', 'event', 'gov', 'utility', 'relief'];

// Model code to Industry Type mapping
// Supports multiple types per model
export const MODEL_TYPE_MAPPING: Record<string, IndustryType[]> = {
  '1RE': ['film'],
  '2RE': ['film'],
  '3RE': ['film'],
  'WEA': ['film'],
  'HNY': ['film', 'event'],
  'CAT': ['event'],
  'VIP': ['event'],
  'CMD': ['gov'],
  'PLL': ['gov'],
  'ENG': ['utility'],
  'FLD': ['utility'],
  'SUR': ['utility'],
  'SLP': ['relief'],
  'ELC': ['relief'],
  'OFF': ['film', 'utility', 'relief'],
  'MED': ['film', 'event', 'relief'],
  'MU4': ['film'],
  'MU5': ['film'],
};

// Origin/Location codes for unit identification
// Format: CODE - Location Name
export const ORIGIN_LABELS: Record<string, string> = {
  'ROAM': 'Mobile/Roaming',
  'TATX': 'Austin, TX',
  'TBM': 'Baltimore, MD',
  'TCA': 'California',
  'TCAL': 'Calgary, AB',
  'TCAN': 'Canada',
  'TCON': 'Connecticut',
  'TDC': 'Washington, DC',
  'TDHS': 'Dallas, TX (DHS)',
  'TDUK': 'Dublin, UK',
  'TGA': 'Georgia',
  'TICE': 'Iceland',
  'TLA': 'Los Angeles, CA',
  'TME': 'Maine',
  'TMLT': 'Malta',
  'TNG': 'Nigeria',
  'TNM': 'New Mexico',
  'TNV': 'Nevada',
  'TNYC': 'New York City, NY',
  'TONC': 'North Carolina',
  'TPR': 'Puerto Rico',
  'TSC': 'South Carolina',
  'TSCE': 'Scotland',
  'TSDG': 'San Diego, CA',
  'TSFO': 'San Francisco, CA',
  'TTX': 'Texas',
  'TUK': 'United Kingdom',
  'TUS': 'United States',
};

// Origins grouped by country/region for dropdown display
export const ORIGIN_GROUPS: { label: string; origins: Array<{ code: string; name: string }> }[] = [
  {
    label: 'Mobile',
    origins: [
      { code: 'ROAM', name: 'Mobile/Roaming' },
    ],
  },
  {
    label: 'United States',
    origins: [
      { code: 'TUS', name: 'United States (General)' },
      { code: 'TCA', name: 'California' },
      { code: 'TLA', name: 'Los Angeles, CA' },
      { code: 'TSDG', name: 'San Diego, CA' },
      { code: 'TSFO', name: 'San Francisco, CA' },
      { code: 'TNYC', name: 'New York City, NY' },
      { code: 'TTX', name: 'Texas' },
      { code: 'TATX', name: 'Austin, TX' },
      { code: 'TDHS', name: 'Dallas, TX (DHS)' },
      { code: 'TGA', name: 'Georgia' },
      { code: 'TDC', name: 'Washington, DC' },
      { code: 'TBM', name: 'Baltimore, MD' },
      { code: 'TCON', name: 'Connecticut' },
      { code: 'TME', name: 'Maine' },
      { code: 'TNM', name: 'New Mexico' },
      { code: 'TNV', name: 'Nevada' },
      { code: 'TONC', name: 'North Carolina' },
      { code: 'TSC', name: 'South Carolina' },
      { code: 'TPR', name: 'Puerto Rico' },
    ],
  },
  {
    label: 'Canada',
    origins: [
      { code: 'TCAN', name: 'Canada (General)' },
      { code: 'TCAL', name: 'Calgary, AB' },
    ],
  },
  {
    label: 'Europe',
    origins: [
      { code: 'TUK', name: 'United Kingdom' },
      { code: 'TDUK', name: 'Dublin, UK' },
      { code: 'TSCE', name: 'Scotland' },
      { code: 'TICE', name: 'Iceland' },
      { code: 'TMLT', name: 'Malta' },
    ],
  },
  {
    label: 'Africa',
    origins: [
      { code: 'TNG', name: 'Nigeria' },
    ],
  },
];

